module.exports = __webpack_public_path__ + "assets/img/b4.cb63e8b7.jpg";